export default __webpack_public_path__ + "static/media/PureWarrior.c05fd3b0.png";